// Dependency
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

// Services
//import CartAPI from "../services/cart.service";
import Storage from "../services/localStorage.service";
import GA from '../services/ga.service.js';

// Hooks
import useMediaQuery from '../hooks/useMediaQuery';

const CartContext = createContext(null)

const CartProvider = ({ currentCountry, location, children }) => {
    const [miniCartOpen, setMiniCartOpen] = useState(false);
    const [quickCartOpen, setQuickCartOpen] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [country, setCountry] = useState(currentCountry);
    const [lastAddedItem, setLastAddedItem] = useState(0)
    const [cart, setCart] = useState(Storage.getWithExpiry('selection') || { token: null, selection: { items: [], address: { country: "" }, discounts: { vouchers: [] }, totals: { grandTotalPriceAsNumber: 0, totalQuantity: 0 } }, shippingMethods: [], location: { country: currentCountry } })

    const toggleMiniCart = () => {
        setMiniCartOpen(!miniCartOpen);
    }

    const toggleQuickCart = () => {
        setQuickCartOpen(!quickCartOpen);
    }

    if (quickCartOpen === true) {
        setTimeout(() => {
            // After 3 seconds set the show value to false
            setQuickCartOpen(false)
        }, 8000)
    }

    const toggleLoading = (state) => {
        setisLoading(state)
    }

    const isTabletOrMobile = useMediaQuery(900)


    //Init Centra Selection
    useEffect(() => {
        if (!cart.token) {
            axios({
                method: 'get',
                url: `${process.env.CENTRA_URL}/selection/`,
            }).then(response => {
                //Check if country needs updating
                let centraCountry = response.data.selection.language === "en" ? "eu" : response.data.selection.language;
                if (response.data.currency === 'GBP') {
                    centraCountry = 'uk';
                }
                console.log(centraCountry, 'centraCountry1');
                console.log(country, 'country1');
                if (country !== centraCountry) {
                    !location.pathname.includes('thankyou') && changeLang(country, response.data);
                } else {
                    setCart(response.data);
                }
            }).catch((error) => {
                console.log(error);
            });
        } else {
            //Check if country needs updating
            let c = cart.selection.language === 'en' ? 'eu' : cart.selection.language;
            if (cart.selection.currency === 'GBP') {
                c = 'uk';
            }
            console.log(c, 'c2');
            console.log(country, 'country2');
            if (country !== c) {
                !location.pathname.includes('thankyou') && changeLang(country, cart);
            } else {
                //Save cart in localStorage
                Storage.setWithExpiry('selection', cart, 302400000);
            }
        }
    }, [cart, country])

    const changeLang = (country, cartInfo) => {
        let c = country;
        if (country === 'eu') {
            c = (cartInfo.location.country === 'SE' || cartInfo.location.country === 'DK' || cartInfo.location.country === 'NO' || cartInfo.location.country === 'GB') ? 'de' : cartInfo.location.country;
        }
        if (cartInfo.token) axios.defaults.headers.put['Accept'] = `*/*;api-token: ${cartInfo.token}`
        axios({
            method: 'put',
            url: `${process.env.CENTRA_URL}/countries/${c === 'uk' ? 'gb' : c}`,
            data: {
                language: country === 'eu' || country === 'uk' ? 'en' : c
            }
        }).then(response => {
            //Update Cart
            setCart(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    //Adds item to cart
    const addToCart = async (itemID, list, centra = false) => {
        // console.log('addToCart item: ', item);
        let listName = list ? list : 'Shop';
        toggleLoading(true);
        if (window.CentraCheckout) window.CentraCheckout.suspend();
        if (centra) GA.addToCart(centra, listName);
        //Set token in header if exists
        let token = Storage.getWithExpiry('selection') ? Storage.getWithExpiry('selection').token : null;
        if (token) axios.defaults.headers.post['Accept'] = `*/*;api-token: ${token}`
        const lineId = axios({
            method: 'post',
            url: `${process.env.CENTRA_URL}/items/${itemID}`,
        }).then(response => {
            //UPdate cart
            setCart(response.data);

            //Get added line id
            if (list === 'Streamify') {
                toggleLoading(false)
                const addedItem = response.data.selection.items.filter(item => item.item === itemID);
                return addedItem[0].line;;
            }

            //Open MiniCart if closed
            if (isTabletOrMobile === true) {
                const addedItem = response.data.selection.items.find(item => item.item === itemID);
                setLastAddedItem(addedItem.line)
                if (quickCartOpen === false && list !== "checkout_upsell") setQuickCartOpen(true);
            }
            else {
                if (miniCartOpen === false && list !== "checkout_upsell") setMiniCartOpen(true);
            }
            //Turn of Loading
            toggleLoading(false)
            window.totalPrice = response.data.selection.totals.grandTotalPriceAsNumber
            if (window.CentraCheckout) window.CentraCheckout.resume();
            return true;
        }).catch((error) => {
            console.log(error);
            toggleLoading(false)
            return true;
        });
        //console.log(lineId)
        return await lineId;
    }
    //Remove all of clicked item from cart
    const removeFromCart = async (lineId, item, qty) => {
        toggleLoading(true);
        if (window.CentraCheckout) window.CentraCheckout.suspend();
        if (item) GA.removeFromCart(item, '', qty);
        let token = Storage.getWithExpiry('selection').token;
        if (token) {
            axios.defaults.headers.delete['Accept'] = `*/*;api-token: ${token}`
            axios({
                method: 'delete',
                url: `${process.env.CENTRA_URL}/lines/${lineId}`,
            }).then(response => {
                //Update Cart
                setCart(response.data)
                window.totalPrice = response.data.selection.totals.grandTotalPriceAsNumber
                if (window.CentraCheckout) window.CentraCheckout.resume();
                //Turn off loading
                toggleLoading(false)
            }).catch((error) => {
                console.log(error);
                toggleLoading(false)
            });
        } else {
            //console.log('No cart');
        }
    }
    //Change qty for item in cart, increase or decrease depending on method
    const changeQty = async (lineId, method = 'post', qty = 1, item, action) => {
        toggleLoading(true);
        if (action === 'add') {
            GA.addToCart(item, 'Mini Cart', qty);
        }
        if (action === 'remove') {
            GA.removeFromCart(item, '', qty);
        }
        if (window.CentraCheckout) window.CentraCheckout.suspend();
        let token = Storage.getWithExpiry('selection').token;
        if (token) {
            axios.defaults.headers[method]['Accept'] = `*/*;api-token: ${token}`
            axios({
                method: method,
                url: `${process.env.CENTRA_URL}/lines/${lineId}/quantity/${qty}`,
            }).then(response => {
                //Save response to localStorage
                setCart(response.data)
                window.totalPrice = response.data.selection.totals.grandTotalPriceAsNumber
                if (window.CentraCheckout) window.CentraCheckout.resume();
                toggleLoading(false)
            }).catch((error) => {
                console.log(error);
                toggleLoading(false)
            });
        }
    }

    const contextObject = {
        cart,
        setCart,
        addToCart,
        removeFromCart,
        changeQty,
        miniCartOpen,
        toggleMiniCart,
        quickCartOpen,
        toggleQuickCart,
        isLoading,
        toggleLoading,
        lastAddedItem
    }

    return (
        <CartContext.Provider value={contextObject}>
            {children}
        </CartContext.Provider>
    )

}
export default CartProvider;

export const useCart = () => useContext(CartContext)